import FileSaver from 'file-saver';
import { call, put } from 'redux-saga/effects';

import { requestApi } from '@app/api';
import blobFactory from '@app/libs/blobFactory';
import { isBrowserNotDownloadable } from '@app/libs/browserUserAgent';
import { modalOpen } from '@app/store/modal/actions';

/**
 * 파일을 새창으로 열기
 * @param url
 */
export function* openFileFromURLSaga(url: string) {
  if (!isBrowserNotDownloadable(navigator.userAgent)) {
    const openedWindow: Window = yield call(window.open, '');
    if (openedWindow) {
      openedWindow.location.href = url;
      openedWindow.opener = null;
    } else {
      yield put(
        modalOpen('CONFIRM', {
          title: '팝업 차단',
          content: '팝업 차단이 설정되어 확인할 수 없습니다.\n차단을 해제(팝업 허용)해 주세요.',
        })
      );
    }
  } else {
    window.location.href = url;
  }
}

export function openFileFromURL(url: string, onBlockPopUp: () => void) {
  if (!isBrowserNotDownloadable(navigator.userAgent)) {
    const openedWindow = window.open('');
    if (openedWindow) {
      openedWindow.location.href = url;
      openedWindow.opener = null;
    } else {
      onBlockPopUp();
    }
  } else {
    window.location.href = url;
  }
}

/**
 * GET 파일 arraybuffer 다운로드(파일데이터 리턴)
 * @param url - 파일 url
 * @returns {object} response - 응답 결과
 */
export function getFileFromURL(url: string): Promise<{ data: ArrayBuffer }> {
  return requestApi<ArrayBuffer>({
    credentials: false,
    disableIEBrowserCache: false,
    method: 'GET',
    responseType: 'arraybuffer',
    url,
  }).then((response) => response);
}

/**
 * 파일 다운로드
 */
export function* downloadFileFromURLSaga({
  url,
  saveFileName,
}: {
  url: string;
  saveFileName: string;
}) {
  // 카카오톡 웹뷰, 네이버앱에서는 다운로드가 제대로 작동하지않아 url로 이동 처리
  if (!isBrowserNotDownloadable(navigator.userAgent)) {
    const response: Awaited<ReturnType<typeof getFileFromURL>> = yield call(getFileFromURL, url);
    const blob: Blob = yield call(blobFactory, response.data);
    yield call(FileSaver.saveAs, blob, saveFileName);
  } else {
    window.location.href = url;
  }
}

export async function downloadFileFromURL({
  url,
  saveFileName,
}: {
  url: string;
  saveFileName?: string;
}) {
  // 카카오톡 웹뷰, 네이버앱에서는 다운로드가 제대로 작동하지않아 url로 이동 처리
  if (!isBrowserNotDownloadable(navigator.userAgent)) {
    const response = await getFileFromURL(url);
    const blob = blobFactory(response.data);
    await FileSaver.saveAs(blob, saveFileName);
  } else {
    window.location.href = url;
  }
}

/**
 * GET 파일 blob 다운로드
 * @param url - 파일 url
 * @returns {object} response - 응답 결과
 */
export function getFileBlobFromURL(url: string): Promise<Blob> {
  return requestApi<Blob>({
    credentials: false,
    disableIEBrowserCache: false,
    method: 'GET',
    responseType: 'blob',
    url,
  }).then((response) => response.data);
}
